/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayCategorySuggestion
 */
export interface AdminEbayCategorySuggestion {
    /**
     * 
     * @type {string}
     * @memberof AdminEbayCategorySuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayCategorySuggestion
     */
    name: string;
    /**
     * Path holds the ancestors' names from the root down to the parent.
     * @type {Array<string>}
     * @memberof AdminEbayCategorySuggestion
     */
    path: Array<string>;
}

export function AdminEbayCategorySuggestionFromJSON(json: any): AdminEbayCategorySuggestion {
    return AdminEbayCategorySuggestionFromJSONTyped(json, false);
}

export function AdminEbayCategorySuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayCategorySuggestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'path': json['path'],
    };
}

export function AdminEbayCategorySuggestionToJSON(value?: AdminEbayCategorySuggestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'path': value.path,
    };
}

